// removed by extract-text-webpack-plugin
module.exports = {"OrderConfirmation":"OrderConfirmation__OrderConfirmation__Vd4xU","Check":"OrderConfirmation__Check__2n1HI","pop":"OrderConfirmation__pop__3Wxx5","Title":"OrderConfirmation__Title__3PW_o","Message":"OrderConfirmation__Message__1GYdu","Paid":"OrderConfirmation__Paid__1Izqy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/OrderConfirmation/OrderConfirmation.css
// module id = 55
// module chunks = 0